module.exports = __webpack_public_path__ + "static/media/events_doodle.3e11a189.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/events_doodle.svg
 ** module id = 2033
 ** module chunks = 44
 **/